<ul class="mainNav-list">
    
    <li class="mainNav-item" *ngIf="isRouteActive('appointments')" (click)="setPage('Calendar')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Calendar' ? 'is-active':''">
            <!-- Calendar -->
            {{'appointments.gui.tabs.Calendar' | translate | titlecase}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('appointments')" (click)="setPage('Patients')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Patients' ? 'is-active':''">
           <!-- Patients -->
           {{'appointments.gui.tabs.Patients' | translate }}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('appointments') && loginService.appointmentsByPatient" (click)="setPage('List')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'List' ? 'is-active':''">
            {{'appointments.gui.tabs.visits And Waiting List' | translate | titlecase}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('appointments')" (click)="setPage('Leads')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Leads' ? 'is-active':''">
            {{'appointments.gui.tabs.Leads' | translate}}
        </span>
    </li>
    <ng-container *ngIf="isRouteActive('appointments')" >
    <li class="mainNav-item" *ngIf="loginService.premissions &&loginService.premissions.Billings" (click)="goBilling();PatientsService.currentPatient=null"  >
        <span class="mainNav-link" >
           <!-- Billings -->
           {{'appointments.gui.tabs.Billings' | translate | titlecase}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="loginService.clinicalAccess">
        <span class="mainNav-link"  (click)="redirectAdministration()">
            {{getButtonText()}}
        </span>
    </li>
    <li *ngIf="loginService.premissions && loginService.premissions.hasMessagingApp" class="mainNav-item" (click)="openMsgApp()">
        <span class="mainNav-link">
            {{'messages.messages-app-dialog' | translate | titlecase}}

            <mat-icon *ngIf="(msgAppAccessService.state$ | async) === 'minimized'" class="open-indicator-icon">aspect_ratio</mat-icon>
    
            <div
                [matBadge]="messageCount$ | async"
                [matBadgeHidden]="(messageCount$ | async) === 0"
                matBadgeColor="warn"
                matBadgePosition="above after"
                aria-label="Notifications for new messages">
            </div>
        </span>
    </li>
    <ng-container>
      <li
        class="mainNav-item"
        *ngIf="isRouteActive('appointments')"
        (click)="setPage('Appointments Stats')"
      >
        <span class="mainNav-link" [ngClass]="currentPage == 'Appointments Stats' ? 'is-active' : ''">
          {{'appointments.gui.tabs.Appointments Stats' | translate}}
        </span>
      </li>
    </ng-container>
    <li class="mainNav-item" *ngIf="loginService.premissions?.FinancialReports && isRouteActive('appointments')" (click)="setPage('Financial Report')">
        <span class="mainNav-link" [ngClass]="currentPage == 'Financial Report' ? 'is-active':''">
            {{'appointments.gui.tabs.Financial Report' | translate}}
        </span>
    </li>
</ng-container>
    <li class="mainNav-item" *ngIf="isRouteActive('settings') || (loginService.premissions?.FinancialReports && isRouteActive('financial'))" (click)="setPage('exams')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'exams' ? 'is-active':''">
           <!-- Exams Settings -->
           {{'appointments.gui.tabs.Exams Settings' | translate | titlecase}}
        </span>
    </li>
    <ng-container *ngIf="loginService.premissions &&loginService.premissions.Appointments">
        <li class="mainNav-item" *ngIf="loginService.premissions &&!loginService.premissions.ApptsByRoom && isRouteActive('settings')" (click)="setPage('Activity Hours')">
            <span class="mainNav-link" [ngClass]="currentPage == 'Activity Hours' ? 'is-active':''">
                <!-- Activity Hours -->
                {{'appointments.gui.tabs.Activity Hours' | translate | titlecase}}
            </span>
        </li>
        <li class="mainNav-item" *ngIf="loginService.premissions &&loginService.premissions.ApptsByRoom && isRouteActive('settings')" (click)="setPage('rooms Activity Hours')">
            <span class="mainNav-link" [ngClass]="currentPage == 'rooms Activity Hours' ? 'is-active':''">
                <!-- Activity Hours -->
                {{'appointments.gui.tabs.Activity Hours' | translate | titlecase}}
            </span>
        </li>
        <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Reports')">
            <span class="mainNav-link" [ngClass]="currentPage == 'Reports' ? 'is-active':''">
                <!-- Reports -->
                {{'appointments.gui.tabs.Reports' | translate | titlecase}}
            </span>
        </li>
        <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Sms')">
            <span class="mainNav-link" [ngClass]="currentPage == 'Sms' ? 'is-active':''">
                <!-- Sms Settings -->
                {{'appointments.gui.tabs.SMS Settings' | translate}}
            </span>
        </li>
        <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Blocks Management')">
            <span class="mainNav-link" [ngClass]="currentPage == 'Blocks Management' ? 'is-active':''">
                {{ 'appointments.gui.tabs.Blocks Management' | translate | titlecase }}
            </span>
        </li>
        <li class="mainNav-item" *ngIf="isRouteActive('settings') && loginService.premissions?.SmsTrackingAppts" (click)="setPage('Sms Tracking')">
            <span class="mainNav-link" [ngClass]="currentPage == 'Sms Tracking' ? 'is-active':''">
                {{'appointments.gui.tabs.SMS Tracking' | translate}}
            </span>
        </li>
        <!-- <li class="mainNav-item" *ngIf="isRouteActive('settings') &&loginService.premissions&& loginService.premissions.hmoAppointments && !loginService.premissions.ApptsByRoom " (click)="setPage('hmoQuota')">
            <span class="mainNav-link" [ngClass]="currentPage == 'hmoQuota' ? 'is-active':''">
              
                {{'appointments.gui.tabs.hmo Quota' | translate}}           
             </span>
        </li> -->
    </ng-container>
    <!-- Questionnaires: gated on its own permission so a questionnaire-only user (no Appointments/Billings) still sees it -->
    <li class="mainNav-item" *ngIf="loginService.premissions?.Questionnaires && isRouteActive('settings')" (click)="setPage('questionnaires')">
        <span class="mainNav-link" [ngClass]="currentPage == 'questionnaires' ? 'is-active':''">
            {{ 'appointments.gui.tabs.Questionnaires' | translate }}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="loginService.premissions && (loginService.premissions.Appointments || loginService.premissions.Billings) && isRouteActive('settings')" (click)="setPage('privateSettings')">
        <span class="mainNav-link" [ngClass]="currentPage == 'privateSettings' ? 'is-active':''">
            <!-- Private price list -->
            {{'appointments.gui.tabs.Private Price List' | translate | titlecase}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="loginService.premissions && (loginService.premissions.Appointments || loginService.premissions.Billings) && loginService.premissions.hmoAppointments && isRouteActive('settings')" (click)="setPage('hmoSettings')">
        <span class="mainNav-link" [ngClass]="currentPage == 'hmoSettings' ? 'is-active':''">
            {{'appointments.gui.tabs.HMO Price List' | translate | titlecase}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="loginService.premissions?.FinancialReports && isRouteActive('financial')" (click)="setPage('Financial Report')">
        <span class="mainNav-link" [ngClass]="currentPage == 'Financial Report' ? 'is-active':''">
            {{'appointments.gui.tabs.Financial Report' | translate}}
        </span>
    </li>
    <li class="mainNav-item" *ngIf="loginService.premissions?.FinancialReports && (isRouteActive('settings') || isRouteActive('financial'))" (click)="setPage('performerPriceList')">
        <span class="mainNav-link" [ngClass]="currentPage == 'performerPriceList' ? 'is-active':''">
            {{'appointments.gui.tabs.Performer Price List' | translate | titlecase}}
        </span>
    </li>
    
</ul>
